import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { ConsumableQuantityEstimationTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<ConsumableQuantityEstimationTheme>;
const css = baseCss as ThemedCssFunction<ConsumableQuantityEstimationTheme>;

export const ConsumableQuantityEstimation = styled.div`
  width: 100%;
  height: 100%;
  margin: 10px;
 .plasma-data-grid{
  margin-top: 10px;
 }
`;
